import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Modal } from 'react-bootstrap';
import { BiHide, BiShow } from 'react-icons/bi';
import { toast } from 'react-toastify';
import SaveButton from '../../component/buttons/SaveButton';
import Loader from '../../component/loader/Loader';
import { changePswRes, changePswTodo } from '../../redux/slices/LoginSlice/ChangePsw';
import PasswordStrengthBar from '../../component/input_filed/PasswordStrengthBar';

export default function UpdatePsw(props) {
  const { show, setShow, userData } = props;
  const dispatch = useDispatch()
  const [spiner, setSpiner] = useState(false);
  const handleClose = () => setShow(false);
  const [currentPsw, setCurrentPsw] = useState(false);
  const [newPswShow, setNewPswShow] = useState(false);
  const [confirmPswShow, setconfirmPswShow] = useState(false);

  const initialValues = {
    id: userData?._id,
    new_psw: "",
    confirm_psw: ''
  };

  const togglePassword = () => {
    setNewPswShow(!newPswShow);
  }
  const togglePassword1 = () => {
    setconfirmPswShow(!confirmPswShow);
  }


  const adminPasswordSchema = Yup.object({
    new_psw: Yup.string().min(6, "Password is too week").required('Password is required'),
    confirm_psw: Yup.string()
      .oneOf([Yup.ref('new_psw'), null], 'Passwords must match')
      .required('Password is required')

  })



  const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: initialValues,
    validationSchema: adminPasswordSchema,
    enableReinitialize: true,

    onSubmit: (values, action) => {
      setSpiner(true)
      dispatch(changePswTodo(values)).then(() => add_res(action))
    }
  });

  const add_res = (action) => {
    if (changePswRes?.status) {
      setShow(false)
      toast.success(changePswRes?.message, { position: 'bottom-right' })
      setSpiner(false)
      action.resetForm()
    } else {
      setShow(false)
      toast.error(changePswRes?.message, { position: 'bottom-right' })
      setSpiner(false)
    }
  }
  return (
    <>
      <Modal show={show} onHide={handleClose} className='password_model'>
        <Modal.Header closeButton>
          <Modal.Title>Update Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
            <div className='mt-2 ps-3 pe-3' style={{ position: 'relative' }}>
              <label htmlFor="user_name" className="form-label form_label">New Password</label>
              {newPswShow ? <span className="psw_icon" onClick={togglePassword} ><BiShow size={20} style={{ color: "grey" }} /></span> : <span className="psw_icon" onClick={togglePassword} ><BiHide size={20} style={{ color: "#9d9d9d" }} /></span>}
              <input type={newPswShow ? "text" : "password"}
                name='new_psw'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.new_psw}
                className='form-control config_filed' />
              <PasswordStrengthBar password={values.new_psw} />
              {errors.new_psw && touched.new_psw ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.new_psw}</span>) : null}
            </div>

            <div className='mt-2 mb-4 ps-3 pe-3' style={{ position: 'relative' }}>
              <label htmlFor="user_name" className="form-label form_label">Conform Password</label>
              {confirmPswShow ?
                <span className="psw_icon" onClick={togglePassword1} > <BiShow size={20} style={{ color: "grey" }} /></span> :
                <span className="psw_icon" onClick={togglePassword1} ><BiHide size={20} style={{ color: "#9d9d9d" }} /></span>}
              <input
                type={confirmPswShow ? "text" : "password"}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.confirm_psw}
                name='confirm_psw'
                className='form-control config_filed' />
              <PasswordStrengthBar password={values.confirm_psw} />
              {errors.confirm_psw && touched.confirm_psw ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.confirm_psw}</span>) : null}
            </div>
            <div className='col-md-12 text-end mt-2'>
              <SaveButton name={'UPDATE'} spiner={spiner} />
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  )
}
